var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('noscript',[_c('img',{staticStyle:{"display":"none"},attrs:{"src":"https://score.juicyscore.com/savedata/?isJs=0"}})])
}]

export { render, staticRenderFns }